// @ts-strict-ignore
import { ComponentProps } from 'react';
import ReactSelectBase from 'react-select';

import { Box } from 'components/Box';

export function ReactSelect({
  label,
  ...props
}: ComponentProps<typeof ReactSelectBase>) {
  return (
    // eslint-disable-next-line jsx-a11y/label-has-associated-control
    <label>
      {label && <Box display="none">{label}</Box>}
      {/* TODO: Fix this the next time the file is edited. */}
      {/* eslint-disable-next-line react/jsx-props-no-spreading */}
      <ReactSelectBase {...props} />
    </label>
  );
}
